export function getS3URL(sourceURL: string): string {
  const url = new URL(sourceURL);
  // remove tennant
  const pathname = url.pathname.substring(url.pathname.indexOf(':')).substring(1);

  return `s3://${pathname}`;
}
